(function () {
    'use strict';

    angular.module("imApp").factory("checkPointsService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1669,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
